import { companyTypes, intervalType } from 'kach-constants'
import { z } from 'zod'
import { conditionsSchema } from './condition-line.schema'
import { REQUIRED_FIELD_MESSAGE } from './invitation.schema'

export const createLimitSchema = conditionsSchema
  .omit({
    conditions: true,
  })
  .extend({
    name: z.string({ required_error: REQUIRED_FIELD_MESSAGE }).nonempty(),
    limit: z
      .number({
        required_error: REQUIRED_FIELD_MESSAGE,
      })
      .nonnegative({ message: 'Debe ser un número positivo' })
      .min(1, {
        message: 'Debe ser un número positivo',
      }),
    type: z.enum(companyTypes, {
      errorMap: (issue, ctx) => ({ message: REQUIRED_FIELD_MESSAGE }),
    }),
    interval: z.enum(intervalType, {
      errorMap: (issue, ctx) => ({ message: REQUIRED_FIELD_MESSAGE }),
    }),
    intervalValue: z.number().nullish(),
    contacts: z
      .array(
        z.object({
          id: z.number().min(1, REQUIRED_FIELD_MESSAGE),
        }),
      )
      .optional(),
    users: z
      .array(
        z.object({
          id: z.number().min(1, REQUIRED_FIELD_MESSAGE),
        }),
      )
      .optional(),
  })
  .refine(
    (data) => {
      if (data.interval === 'ever') return true

      return data.intervalValue != null
    },
    {
      path: ['intervalValue'],
      message: REQUIRED_FIELD_MESSAGE,
    },
  )
  .refine(
    (data) => {
      if (data.type === 'lab') {
        return data.contacts && data.contacts.length >= 1
      }
      return true
    },
    {
      path: ['contacts'],
      message: 'Debe seleccionar al menos un estudio cuando el tipo es Estudio',
    },
  )

export type CreateLimitSchema = z.infer<typeof createLimitSchema>
